export enum ETipoMovimentoFinanceiro {
  Todos = 0,
  Recebimento = 1,
  Pagamento = 2,
}
